module.exports = __webpack_public_path__ + "b17c55b7.svg";